import { gql, useMutation } from '@apollo/client'

export const COUNT_CAMPAIGN_VIEW = gql`
    mutation CountCampaignView($input: CountCampaignViewsInput!) {
        countCampaignViews(input: $input) {
            success
        }
    }
`

export const useCountCampaignView = () => {
  const [mutate, { data, error, loading }] = useMutation(COUNT_CAMPAIGN_VIEW)
  return { mutate, data, error, loading }
}
